import { render, staticRenderFns } from "./DetalheTitulo.vue?vue&type=template&id=cdf79ece&scoped=true"
import script from "./DetalheTitulo.vue?vue&type=script&lang=js"
export * from "./DetalheTitulo.vue?vue&type=script&lang=js"
import style0 from "./DetalheTitulo.vue?vue&type=style&index=0&id=cdf79ece&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf79ece",
  null
  
)

export default component.exports